module.exports = __webpack_public_path__ + "static/media/Anshika Polysurf.5ad36341.webp";